import { ShippingAndHandling, ShipViaOption } from '../../api/models/order-detail';
import { DisplayMessageModalComponent } from '../display-message-modal/display-message-modal.component';
import { Component, Injectable, OnInit, ViewChild } from '@angular/core';
import { MarketService } from '../../api/services/market.service';
import { NgbModal, NgbDateStruct, NgbDateAdapter, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
import { PreferencesService } from '../../api/services/preferences.service';
import { AuthService } from '../../api/services/auth.service';
import { ProjectService } from '../../api/services/project.services';
import { ActivatedRoute, Router } from '@angular/router';
import { Address } from '../../api/models/address';
import { AddressCreationComponent } from '../address-creation/address-creation.component';
import { Observable } from 'rxjs/Observable';
import { BomLine } from '../../api/models/bom-line';
import { BomTableService } from '../bom-table/bom-table.service';
import { UserService } from '../../api/services/user.service';
import { map } from 'rxjs/operators';
import { Worksheet } from '../../api/models/worksheet';
import { CheckoutService } from './checkout.service';
import { forkJoin } from 'rxjs/observable/forkJoin';
import { DownloadCopyComponent } from '../order-worksheet/download-copy/download-copy.component';
import { Order } from '../../api/models/order';
import { RoleRequest } from '../../api/models/role-assignment-map';
import { of } from 'rxjs/observable/of';
import { ProductAliasService } from '../../api/services/product-alias.service';
import { OrderSimulation } from '../../api/models/order-simulation';
import { QuoteRequest } from '../../api/models/quote-request';
import { OrderDetail } from '../../api/models/order-detail';
import { Subject } from 'rxjs/Subject';
import { NgModel } from '@angular/forms';
import { Market } from '../../api/models/market-model';
import { ConfirmationModalComponent } from '../confirmation-modal/confirmation-modal.component';
import { TasksService } from '../../api/services/tasks.service';
import { Task } from '../../api/models/task';
import { InfoModalComponent } from '../info-modal/info-modal.component';
import { ToastrService } from 'ngx-toastr';
import { Location } from '@angular/common';
import { AnalyticsService } from '../../api/services/analytics.service';

/**
 * This Service handles how the date is represented in scripts i.e. ngModel.
 */
@Injectable()
export class CustomAdapter extends NgbDateAdapter<string> {

  readonly DELIMITER = '/';

  fromModel(value: string | null): NgbDateStruct | null {
    if (value) {
      let date = value.split(this.DELIMITER);
      let today = new Date();
      let yearPrefix = today.getFullYear() + '';
      date[2] = yearPrefix.slice(0,2) + date[2];
      return {
        day : parseInt(date[1], 10),
        month : parseInt(date[0], 10),
        year : parseInt(date[2], 10)
      };
    }
    return null;
  }

  toModel(date: NgbDateStruct | null): string | null {
    if(date) {
      let year = date.year + '';
    let day = date.day < 10 ? '0' + date.day : date.day;
    let month = date.month < 10 ? '0' + date.month : date.month;
    return month + this.DELIMITER + day + this.DELIMITER + year.slice(-2);
    } else {
      return '';
    }
  }
}

/**
 * This Service handles how the date is rendered and parsed from keyboard i.e. in the bound input field.
 */
@Injectable()
export class CustomDateParserFormatter extends NgbDateParserFormatter {

  readonly DELIMITER = '/';

  parse(value: string): NgbDateStruct | null {
    if (value) {
      let date = value.split(this.DELIMITER);
      let today = new Date();
      let yearPrefix = today.getFullYear() + '';
      date[2] = yearPrefix.slice(0,2) + date[2];
      return {
        day : parseInt(date[1], 10),
        month : parseInt(date[0], 10),
        year : parseInt(date[2], 10)
      };
    }
    return null;
  }

  format(date: NgbDateStruct | null): string {
    if(date) {
      let year = date.year + '';
    let day = date.day < 10 ? '0' + date.day : date.day;
    let month = date.month < 10 ? '0' + date.month : date.month;
    return month + this.DELIMITER + day + this.DELIMITER + year.slice(-2);
    } else {
      return '';
    }
  }
}

@Component({
  selector: 'app-checkout',
  templateUrl: './checkout.component.html',
  styleUrls: ['./checkout.component.scss'],
  providers: [
    /**
     * This 2 provider are only for this component and not for the app module.
     * This is because we cannot provide dynamic date format and if we put it in app module
     * then all date picker will follow the MM/DD/YY format
     */
    {provide: NgbDateAdapter, useClass: CustomAdapter},
    {provide: NgbDateParserFormatter, useClass: CustomDateParserFormatter},
    BomTableService
  ]
})
export class CheckoutComponent implements OnInit {

  VERIZON_DATE_FORMAT_REGEX = '(0[1-9]|1[012])/(0[1-9]|[12][0-9]|3[01])/([0-9]{2})';
  @ViewChild('pdd') pdd:NgModel;
  @ViewChild('pid') pid:NgModel;
  @ViewChild('prdd') prdd:NgModel;
  //For Verizon only
  @ViewChild('gerf') gerf:NgModel;
  @ViewChild('gera') gera:NgModel;
  @ViewChild('mrd') mrd:NgModel;
  confirmAddress = false;

  loading = true;

  disablePoNum = false;

  worksheet: Worksheet;

  order: Order;

  step: number;

  roles: string[] = [];

  addresses: Address[];

  market: Market;

  toBeDetermined = false;

  selectedAddressId: string;
  previousSelectedAddressId: string;
  clearShipAmountFlag: boolean = false;

  secondaryAddress: Address = new Address();

  worksheetMarketId: string;

  worksheetId: string;

  bomId: string;

  showPricing = false;

  packingListInside = false;

  showInstructions = false;

  specialShippingInstructions = '';

  backorderedItems: boolean;

  customDeliveryDate = false;

  customShippingMethod = false;

  customCodeSelected = '05';

  dayDelivery = 3;

  options = [1, 2, 3, 4];

  codeSelected = '1';

  bomData: Observable<BomLine[]>;

  simulationDataForBomTable: Observable<OrderSimulation>;
  orderSimulationData: OrderSimulation;
  orderDetail: OrderDetail;

  quoteRequest = new QuoteRequest();
  showBomTable = false;

  poNumber: string;
  poDueDate: string;
  poIssueDate: string;
  proDelDate: string;

  //For Verizon only
  grpEquipRecvdF: string;
  grpEquipRecvdA: string;
  mrDate: string;

  projectNumber: string;

  errorSubmittingQuote = false;
  warningSubmittingquote = false;

  userIds = [];

  organizationId: string;

  submittingQuote = false;

  submittingOrder = false;

  canViewPricing = false;

  serverError: [boolean, string] = [false, ''];

  quoteServerError = false;

  paymentServerError = false;

  orderServerError = false;

  isAtc = false;
  isVerizon = false;

  generatePORRequired =false;
  roleRequest: RoleRequest;
  products: any;
  shippmentTypeMessage: string = '';
  shippmentFlag: boolean = false;

  minDate: NgbDateStruct;
  deliveryDateChange = false;

  // step 2 variables
  waitToShip = false;
  onlyBackorderedToShip = false;
  backOrderedOnly = false;
  inStockOnly = false;
  shipViaCodeSelected = '';
  customDateSelected = new Date().toISOString();
  completeDelivery = false;
  currentDate = new Date();
  isBackOrdered: boolean;
  errorMessages$: Subject<string[]> = new Subject();
  warningMessages$: Subject<string[]> = new Subject();
  allBackOrdered: boolean = false;
  allInStock: boolean = false;

  isTesscoAdmin = false;
  averageTimeForSimulation: string;
  shippingAndHandling: ShippingAndHandling;
  accountNumber: string;
  isPdgPriceCalculated: boolean = false;
  showCalculatePDGAllButton: boolean = true;
  backToSearch: string;

  constructor(private marketService: MarketService,
    private modalService: NgbModal,
    private preferencesService: PreferencesService,
    private authService: AuthService,
    private projectService: ProjectService,
    private activatedRoute: ActivatedRoute,
    private userService: UserService,
    private checkoutService: CheckoutService,
    private productAliasService: ProductAliasService,
    private ngbDateParserFormatter: NgbDateParserFormatter,
    private taskService: TasksService,
    private toastr: ToastrService,
    private location: Location,
    private router: Router,
    private analyticsService: AnalyticsService
  ) { }


  ngOnInit() {
    this.activatedRoute.queryParams.subscribe(params => {
      this.backToSearch = params['backToSearch'];
    });
    
    this.activatedRoute
      .params.map(p => p.id)
      .switchMap(id => {
        this.worksheetId = id;
        return this.projectService.getWorksheet(id);
      })
      .switchMap(worksheet => {
          if (this.userService.isMarketPermittedForCurrentUser(worksheet.project.marketId)) {
            this.worksheet = worksheet;
          } else {
            this.loading = false;
            this.worksheet = null;
            this.errorMessages$.next(["You don't have permission to view this page!!!"]);
          }
          if (this.worksheet) {
            this.poNumber = worksheet.purchaseOrderNumber;
            if(this.poNumber){
              this.disablePoNum = true;
            }
            this.setRequiredRoles();
            this.setRequiredPreference();
            this.selectedAddressId = this.worksheet.shipToAddressId;
            this.previousSelectedAddressId = this.selectedAddressId;
            if (!this.worksheet.shipToAddressId) {
              this.toBeDetermined = true;
            }
            this.worksheetMarketId = this.worksheet.project.marketId;
            this.organizationId = this.worksheet.project.organizationId;
            return forkJoin(this.marketService.getMarket(this.worksheetMarketId),
              this.authService.getUserRolesInContext(`WORKSHEET~${this.worksheetId}`),
              this.projectService.getOrderSimulation(this.worksheetId),
              this.taskService.getTasksByWorksheetId(this.worksheetId))
          }  else {
            return forkJoin(of({}),of({}),of({}),of({}));
          }
      }).subscribe((data: [Market, any, OrderDetail, Task[]]) => {
        if (this.worksheet) {
          this.market = data[0];
          this.roles = data[1];
          this.orderDetail = data[2];
          this.addresses = this.market.shippingAddresses;
          this.addresses.forEach(address => {
            if (address.locationName.length > 30) {
              address.shortLocationName = address.locationName.slice(0, 30) + '...';
            }
          });
          this.accountNumber = this.market.accountNumber;
          this.shippingAndHandling = this.orderDetail.shippingAndHandling;
          this.allBackOrdered = this.orderDetail.orderLines.every(line => line.quantity !== line.quantityAvailable);
          this.isBackOrdered = this.allBackOrdered || this.orderDetail.orderLines.some(line => line.quantity !== line.quantityAvailable);
          this.setAdditionalOptions(this.orderDetail);    
          if (this.isAtc == true) {
            if (!this.worksheet.isQuoted) {
             // setting the prices to null, once calculate PDG is clicked price is displayed.
             this.resetShipViaCodeAndItsPrice();
            }
          } else if (this.isVerizon == true) {
            if (!this.worksheet.isQuoted && this.worksheet.approvalStatus!='TESSCO_REVIEW'){
              this.resetShipViaCodeAndItsPrice();
            }
          }
          if (this.worksheet.isQuoted && this.worksheet.quoteNumber) {
            if (this.roles.includes('ORDER_SUBMIT')) {
              this.step = 3;
              this.showWarningMessageIfAnyOpenTasksExists(data[3]);
              this.loading = false;
            } else {
              this.step = 4;
              this.loading = false;
            }
          } else if (this.isVerizon && this.isTesscoAdmin && this.worksheet.approvalStatus === 'TESSCO_REVIEW') {
            this.step = 3;
            this.loading = false;
          } else {
            this.loading = false;
            this.step = 1;
          }
          const skus = this.orderDetail.orderLines.map(orderLine => orderLine.sku);
          this.productAliasService.productDetailsV2(skus, this.market.accountNumber).subscribe(products => {
            this.products = products;
            this.filterShipViaOptionsIfHazmatItemPresent();
            this.checkBulkOrParcel(false);
          });
        }
      }, error => {
        this.loading = false;
        const message = error.error.message ? error.error.message.split("\n") : ['Internal Server Error.'];
        this.errorMessages$.next([message]);
      });
  }

  private filterShipViaOptionsIfHazmatItemPresent() {
    if (this.products.some(product => product.isHazmatItem === true)) {
      this.orderDetail.shipViaOptions = this.orderDetail.shipViaOptions
        .filter(ship => ship.code === "05" || ship.code === "03" || ship.code === "PU");
      this.showCalculatePDGAllButton = true;
    }
  }

  setDefaultAdditionalOptions() {
    (this.quoteRequest.packingListLocation == undefined) ? this.quoteRequest.packingListLocation = 'O' : this.quoteRequest.packingListLocation;
    (this.quoteRequest.invoiceLocation == undefined) ? this.quoteRequest.invoiceLocation = 'O' : this.quoteRequest.invoiceLocation;
    (this.quoteRequest.isPackingListPriced == undefined) ? this.quoteRequest.isPackingListPriced = false : this.quoteRequest.isPackingListPriced;
    (this.quoteRequest.packingListCopiesCount == undefined) ? this.quoteRequest.packingListCopiesCount = 2 : this.quoteRequest.packingListCopiesCount;
  }

  setAdditionalOptions(orderDetail : OrderDetail) {
    if (orderDetail.orderOption.completeDelivery === true) {
      this.quoteRequest.completeDelivery = Boolean(orderDetail.orderOption.completeDelivery);
    } else {
      this.quoteRequest.completeDelivery = Boolean(0);
    }
    this.averageTimeForSimulation = this.orderDetail.orderOption.averageTimeForSimulation;
  }

  setRequiredPreference() {
    this.preferencesService.getPreferences('CUSTOMER', this.worksheet.project.organizationId).subscribe(prefs => {
      this.isAtc = prefs['special-fields'].Value === 'ATC';
      this.isVerizon = prefs['special-fields'].Value === 'Verizon eQuote';
    });
    this.preferencesService.getPreferences('PROJECT', this.worksheet.projectId).subscribe(preference => {
      if(preference) {
        this.projectNumber = preference['oracle-project-number'] ? preference['oracle-project-number'].Value : null;
      }
    });
    this.preferencesService.getPreferences('WORKSHEET', this.worksheet.id).subscribe(prefs => {
      if (prefs) {
        this.poIssueDate = prefs['purchase-order-issue-date'] ? prefs['purchase-order-issue-date'].Value : null;
        this.poDueDate = prefs['purchase-order-delivery-date'] ? prefs['purchase-order-delivery-date'].Value : null;
        this.proDelDate = prefs['promise-delivery-date'] ? prefs['promise-delivery-date'].Value : null;
        this.grpEquipRecvdF = prefs['group-equipment-received-f-date'] ? prefs['group-equipment-received-f-date'].Value : null;
        this.grpEquipRecvdA = prefs['group-equipment-received-a-date'] ? prefs['group-equipment-received-a-date'].Value : null;
        this.mrDate = prefs['mr-date'] ? prefs['mr-date'].Value : null;
      }
    });
  }

  setRequiredRoles() {
    this.roleRequest = new RoleRequest('PRICING_VIEW', null);
    this.roleRequest.setRoleAndContextMap("ADMIN_TESSCO",null);
    this.authService.getUserRoles(this.roleRequest).subscribe(roles => {
      this.canViewPricing = roles.getRoleMap('PRICING_VIEW');
      this.isTesscoAdmin = roles.getRoleMap('ADMIN_TESSCO');
    });
  }
  // steps methods

  changeStep(step: number) {
    if (step < this.step && this.step !== 4) {
      this.step = step;
      //Clearing Ship Via Amount values when user switches to other phase
      this.clearShippingAmount(true);
    }
  }

  clearShippingAmount(fromChangeStep: boolean){
    this.orderDetail.shipViaOptions.forEach((shipViaOption) => {
      if(fromChangeStep){
        if(shipViaOption.code != this.orderDetail.orderOption.shipViaCode){
          shipViaOption.extraFees = null;
          shipViaOption.merchandiseAmountToShip = null;
          shipViaOption.regularAmount = null;
          shipViaOption.taxAmount = null;
          shipViaOption.totalChargeAmount = null;
          this.clearShipAmountFlag = false;
        }
      } else {
        shipViaOption.extraFees = null;
        shipViaOption.merchandiseAmountToShip = null;
        shipViaOption.regularAmount = null;
        shipViaOption.taxAmount = null;
        shipViaOption.totalChargeAmount = null;
        this.clearShipAmountFlag = true;
      }
    });
  }

  goToDelivery() {
    if(this.previousSelectedAddressId != this.selectedAddressId){
      this.clearShippingAmount(false);
      this.previousSelectedAddressId = this.selectedAddressId;
    }

    if(this.toBeDetermined){
      this.updateShipTo(this.selectedAddressId, false);
      this.step = 2;
    }else{
      this.checkBulkOrParcel(true);
    }
  }

  goToReviewOrder() {
    this.suscribeUsersShippingNotifications();
    if (!this.isPdgPriceCalculated) {
      this.loading = true;
      this.quoteRequest.worksheetId = this.worksheetId;
      this.quoteRequest.shipViaOption = this.orderDetail.orderOption.shipViaCode;
      this.quoteRequest.requestedDeliveryDate = this.orderDetail.orderOption.requestedDeliveryDate;
      this.quoteRequest.isCustomDelivery = this.orderDetail.orderOption.isCustomDelivery;
      this.quoteRequest.isCheckout = true;
      this.projectService.getOrderSimulation2(this.quoteRequest).subscribe(data => {
        this.orderDetail = data;
        this.shippingAndHandling = this.orderDetail.shippingAndHandling;
        this.checkBulkOrParcel(false);
        this.filterShipViaOptionsIfHazmatItemPresent();
        this.loading = false;
      });
    }
    this.step = 3;
  }

  placeOrder() {
    this.clearErrorAndWarnings();
    if(!this.poNumber) {
      this.errorMessages$.next(['Please enter a valid PO number']);
      return;
    }
    if (!((this.pdd.value && this.pdd.value.length && this.pdd.invalid)
              || (this.pid.value && this.pid.value.length && this.pid.invalid)
              || (this.prdd.value && this.prdd.value.length && this.prdd.invalid))) {

      if (this.isVerizon) {
        if (!((this.gerf.value && this.gerf.value.length && this.gerf.invalid)
          || (this.gera.value && this.gera.value.length && this.gera.invalid)
          || (this.mrd.value && this.mrd.value.length && this.mrd.invalid))) {
        forkJoin(
          this.preferencesService.setPreference('WORKSHEET', this.worksheet.id, 'group-equipment-received-f-date', { Value: this.grpEquipRecvdF }),
          this.preferencesService.setPreference('WORKSHEET', this.worksheet.id, 'group-equipment-received-a-date', { Value: this.grpEquipRecvdA }),
          this.preferencesService.setPreference('WORKSHEET', this.worksheet.id, 'mr-date', { Value: this.mrDate })
          ).subscribe();
        } else {
          this.submittingOrder = false;
          this.errorMessages$.next(['Invalid Date Format entered']);
          return;
        }
      }
      this.submittingOrder = true;

      this.preferencesService.setPreference('WORKSHEET', this.worksheet.id, 'purchase-order-issue-date', { Value: this.poIssueDate }),
      this.preferencesService.setPreference('WORKSHEET', this.worksheet.id, 'purchase-order-delivery-date', { Value: this.poDueDate }),
      this.preferencesService.setPreference('WORKSHEET', this.worksheet.id, 'promise-delivery-date', { Value: this.proDelDate })

      this.quoteRequest.worksheetId = this.worksheetId;
      this.quoteRequest.shipViaOption = this.orderDetail.orderOption.shipViaCode;
      this.quoteRequest.purchaseOrderNumber = this.poNumber;
      this.quoteRequest.customerPOIssueDate = this.poIssueDate;
      this.quoteRequest.originalPromiseDeliveryDate = this.proDelDate;
      this.quoteRequest.poDeliveryDate = this.poDueDate;

      this.projectService.getBomLines(this.worksheet.bomId).subscribe(lines => {
        // Check if any of the PO line numbers are null.
        const hasNullPoLineNumber = lines.some(line => line.poLineNumber === null || line.poLineNumber=== 2000);

        if (hasNullPoLineNumber) {
          this.submittingOrder = false;
          const modalRef = this.modalService.open(ConfirmationModalComponent, {
            backdrop: 'static',
            size: 'lg',
            keyboard: false
          });
          modalRef.componentInstance.headerMsg = "Warning!";
          let msg = '<br/><br/>Note: To enter <strong>PO line </strong> numbers, click on Cancel and enter the PO line numbers under the <strong>Order Summary</strong> Section.'
          modalRef.componentInstance.bodyMsg = `The <strong>PO line </strong> numbers have not been entered for certain SKUs. Are you sure you want to place the order without them ?` + msg;
          modalRef.componentInstance.primaryButtonText = "Yes, Proceed";
          modalRef.componentInstance.fn = () => {
            modalRef.close();
            this.submitOrder();
          };
        } else {
          this.submitOrder();
        }
      });
    }
  }

  private submitOrder() {
    this.submittingOrder = true;
    this.checkoutService.submitOrderV2(this.worksheetId, this.quoteRequest).subscribe(order => {
      this.order = order;
      if (!this.order.orderNumber) {
        this.submittingOrder = false;
        this.errorMessages$.next(['There was an error placing the Order.']);
      } else {
        this.step = 4;
        this.sendDataToAnalytics('order_submission', this.order.orderNumber);
      }
    }, error => {
      const message = error.error.message ? error.error.message.split("\n") : ['There was an error placing the Order.'];
      this.submittingOrder = false;
      this.errorMessages$.next(message);
    });
  }

  submitQuote() {
    this.clearErrorAndWarnings()
    this.submittingQuote = true;
    this.quoteRequest.worksheetId = this.worksheetId;
    this.quoteRequest.isRealQuote = true;
    this.quoteRequest.shipViaOption = this.orderDetail.orderOption.shipViaCode;
    this.quoteRequest.requestedDeliveryDate = this.orderDetail.orderOption.requestedDeliveryDate;
    this.quoteRequest.isCustomDelivery = this.orderDetail.orderOption.isCustomDelivery;

    if (this.isAtc) {
      if (this.isTesscoAdmin) {
        this.quoteRequest.generatePORRequired = this.generatePORRequired;
      } else {
        this.quoteRequest.generatePORRequired = true;
      }
    }

    this.checkoutService.submitQuoteV2(this.worksheetId, this.quoteRequest).subscribe(quote => {
      this.quoteServerError = false;
      this.orderDetail = quote;
      if (this.orderDetail.quoteNumber) {
        this.step = 4;
        this.submittingQuote = false;
        this.sendDataToAnalytics('quote_submission', this.orderDetail.quoteNumber);
      } else {
        this.errorSubmittingQuote = true;
        this.submittingQuote = false;
        this.errorMessages$.next(['There was an error placing the Quote.']);
      }
    }, error => {
      this.submittingQuote = false;
      const message = error.error.message ? error.error.message.split("\n") : ['There was an error placing the Quote.'];
      this.errorMessages$.next(message);
    });
  }

  approve() {
    this.submittingQuote = true;
    this.quoteRequest.worksheetId = this.worksheetId;
    this.quoteRequest.shipViaOption = this.orderDetail.orderOption.shipViaCode;
    this.quoteRequest.requestedDeliveryDate = this.orderDetail.orderOption.requestedDeliveryDate;
    this.quoteRequest.isCustomDelivery = this.orderDetail.orderOption.isCustomDelivery;
    this.quoteRequest.forceSimulation = true;

    this.checkoutService.submitForTesscoReviewV2(this.worksheetId, this.quoteRequest)
      .subscribe(worksheet => {
        this.worksheet = worksheet;
        this.quoteServerError = false;
        if (this.worksheet.approvalStatus === 'TESSCO_REVIEW') {
          this.step = 5;
        } else {
          this.submittingQuote = false;
          this.errorMessages$.next(['There was an error approving the worksheet']);
        }
      }, error => {
        this.submittingQuote = false;
        this.errorMessages$.next(['There was an error approving the worksheet']);
      });
  }

  editShipping() {
    this.step = 1;
  }

  editDelivery() {
    this.step = 2;
  }


  // step 1

  checkBulkOrParcel(onButtonClick: boolean){
    this.shippmentFlag = false;
    const addr = this.addresses.find(a => a.id === this.selectedAddressId);
    let isBulk = this.checkProductForBulk();

    if(isBulk) {
      if(addr && !addr.acceptBulk){
        this.shippmentFlag = true;
        this.warningMessages$.next(['Selected Order is of type Bulk. Please select Bulk Shipping Address']);
      }
      this.orderDetail.shipViaOptions = this.orderDetail.shipViaOptions
      .filter(ship =>ship.code!='01' && ship.code!='02' && ship.code!='U7');
      this.showCalculatePDGAllButton = true; 
    } else {
      if(addr && !addr.acceptParcel){
        this.shippmentFlag = true;
        this.warningMessages$.next(['Selected Order is of type Parcel. Please select Parcel Shipping Address']);
      }
    }
    if(onButtonClick && !this.shippmentFlag){
      this.updateShipTo(this.selectedAddressId, this.confirmAddress);
      this.step = 2;
    }
  }

  checkProductForBulk(){
    let isBulk: boolean = false;
    let totalWeight = 0;
    //If any one product is Bulk, then considering entire shippment as Bulk
    this.products.forEach(product => {
      if(!isBulk){
        const orderLine = this.orderDetail.orderLines.find(ol => (ol.sku === product.sku));
        if(orderLine){
          totalWeight += orderLine.quantity * product.weight;

          if(totalWeight > 250){
            isBulk = true;
            this.shippmentTypeMessage = 'Selected Order weighs more than 250lbs. Please select Bulk Shipping Address';
          }
        }
      }
    });
    return isBulk;
  }

  createNewAddress() {
    this.clearErrorAndWarnings();
    this.toBeDetermined = false;
    const modalRef = this.modalService.open(AddressCreationComponent, {
      backdrop: 'static',
      keyboard: false
    });
    modalRef.componentInstance.marketId = this.worksheetMarketId;
    modalRef.result.then((newAddress: Address) => {
      this.marketService.getAddresses(this.worksheetMarketId).subscribe(addresses => {
        this.selectAddress(newAddress);
        this.addresses = addresses;
      });
    });
  }

  selectAddress(address: Address) {
    this.clearErrorAndWarnings();
    this.toBeDetermined = false;
    this.previousSelectedAddressId = this.selectedAddressId;
    this.selectedAddressId = address.id;
    this.secondaryAddress = new Address();
    this.updateShipTo(this.selectedAddressId, this.confirmAddress);
  }

  setToBeDeterminedAddress() {
    this.clearErrorAndWarnings();
    this.previousSelectedAddressId = this.selectedAddressId;
    this.selectedAddressId = null;
    this.toBeDetermined = true;
  }

  updateShipTo(addressId: string, confirmed: boolean) {
    this.worksheet.shipToAddressId = addressId;
    this.worksheet.confirmedShipToAddressId = addressId  ? true : false;
    this.projectService.updateWorksheet(this.worksheetId, this.worksheet).subscribe();
  }

  needSecondAddress() {
    if (this.toBeDetermined) {
      return false;
    } else {
      return (this.needBulk() || this.needParcel());
    }
  }

  needBulk() {
    const addr = this.addresses.find(a => a.id === this.selectedAddressId);
    return !addr.acceptBulk;
  }

  needParcel() {
    const addr = this.addresses.find(a => a.id === this.selectedAddressId);
    return !addr.acceptParcel;
  }

  getMessageSecondaryAddress() {
    if (this.needBulk() && this.needParcel()) {
      return 'A secondary address is required to support shipments that will accept bulk and parcel shipments';
    } else if (this.needBulk()) {
      return 'A secondary address is required to support bulk shipments';
    } else if (this.needParcel()) {
      return 'A secondary address is required to support parcel shipments';
    }
  }

  getAddressPB() {
    if (this.needBulk() && this.needParcel()) {
      return this.addresses.filter(a => a.acceptBulk && a.acceptParcel);
    } else if (this.needBulk()) {
      return this.addresses.filter(a => a.acceptBulk);
    } else {
      return this.addresses.filter(a => a.acceptParcel);
    }
  }

  setSecondaryAddress(addressId: string) {
    this.secondaryAddress = this.addresses.find(a => a.id === addressId);
    this.worksheet.secondaryAddressId = addressId;
    this.projectService.updateWorksheet(this.worksheetId, this.worksheet).subscribe();
  }

  suscribeUsersShippingNotifications() {
    this.userIds.map(user => user.value).forEach(userId => {
      this.projectService.addShipmentNotificationUser(userId, this.worksheet.id).subscribe();
    });

  }

  setDeliveryDate(code: string){
    this.shipViaCodeSelected = code;
    this.customDeliveryDate = false;
    this.customShippingMethod = false;

    let date = new Date();
    date.setDate(date.getDate() + this.getDaysTobeAdded(code));

    this.customDateSelected = date.toISOString();
    this.quoteRequest.requestedDeliveryDate = this.customDateSelected;
  }

  getDeliverySpeed(code: string) {
    switch (code) {
      case '00':
        return 'Same day Shipment Ground';
      case '01':
        return '1 Day Air';
      case '02':
        return '2 Day Air';
      case '03':
        return '3 Day Air';
      case '05':
        return '5 Day Ground';
      case '48':
        return '48 Hour Shipment Ground';
      case 'U7':
        return 'US Mail';
      case 'PU':
        return 'Customer Pickup Same Day';
      case 'P1':
        return 'Customer Pickup Later';
      case '31':
        return '3rd Party/Collect 1 Day Air';
      case '32':
        return '3rd party/Collect 2 Day Air';
      case '33':
        return '3rd Party/Collect 3 Day Air';
      case '35':
        return '3rd Party/Collect 5 Day';
      case 'RE':
        return 'Returns';
      case 'CC':
        return 'Consignment Returns/Issues';
    }
  }

  getTransitDayOrDate(code: string, isDate: boolean) {
    // Need to add logic if user selects code 'RE'
    var date = new Date(this.currentDate);
    date.setDate(date.getDate() + this.getDaysTobeAdded(code));
    const dayNumber = date.getDay();

    // Below code is to return Date
    if(isDate){
      switch (dayNumber) {
        case 0:
          return new Date(date).setDate(date.getDate() + 1);
        case 6:
          return new Date(date).setDate(date.getDate() + 2);
        default:
          return date;
      }
    }

    // Below code is to return Day
    switch (dayNumber) {
      case 0:
      case 6:
      case 1:
        return 'Monday';
      case 2:
        return 'Tuesday';
      case 3:
        return 'Wednesday';
      case 4:
        return 'Thursday';
      case 5:
        return 'Friday';
    }
}

  getDaysTobeAdded(code: string){
    switch(code){
      case '01':
      case 'P1':
      case '31':
        return 1;
      case '02':
      case '48':
      case '32':
        return 2;
      case '03':
      case '33':
        return 3;
      case '05':
      case '35':
        return 5;
      case 'U7':
        return 7;
      default:
        return 0;
    }
  }

  setPackingCopiesQty(qty: number) {
    this.quoteRequest.packingListCopiesCount = qty;
  }

  autocompleteUsers = (text: string) => {
    return this.userService.findUserByOrganizationIdAndText(this.organizationId, text)
      .pipe(map(data => data.map(user => [`${user['First Name']} ${user['Last Name']}`, user['User ID']])));
  }

  setCustomDeliveryDate() {
    this.customDeliveryDate = true;
    this.onSelectingCustomShipment('05');
    this.orderDetail.orderOption.isCustomDelivery = true;
  }

  onShipDateSelect(date: NgbDateStruct) {
    const btn: any = document.getElementById('datePick');
    this.orderDetail.orderOption.requestedDeliveryDate = this.formatDate(date);
    btn.value = 'Change';
  }

  onSelectingCustomShipment(shipViaCode: string) {
    this.customCodeSelected = shipViaCode;
    this.orderDetail.orderOption.shipViaCode = shipViaCode;
    this.isPdgPriceCalculated = false;
  }

  formatDate(date: NgbDateStruct): string {
    return this.ngbDateParserFormatter.format(date);
  }

  // step 3
  getAddress(addressId: string): string {
    if (this.toBeDetermined) {
      return 'To Be Determined';
    } else {
      const address = this.addresses.filter(a => a.id === addressId)[0];
      return `${address.line1}, ${address.city} ${address.state}, ${address.zip}`;
    }
  }

  showSummary() {
    this.showBomTable = !this.showBomTable;
    this.bomData = this.projectService.getBomLines(this.worksheet.bomId);
    this.bomId = this.worksheet.bomId;
    this.accountNumber = this.market.accountNumber;
    this.quoteRequest.worksheetId = this.worksheetId;
    this.quoteRequest.shipViaOption = this.orderDetail.orderOption.shipViaCode;
    this.quoteRequest.requestedDeliveryDate = this.orderDetail.orderOption.requestedDeliveryDate;
    this.quoteRequest.isCustomDelivery = this.orderDetail.orderOption.isCustomDelivery;
    this.quoteRequest.isCheckout = true;
    this.simulationDataForBomTable = this.projectService.getOrderSimulation2(this.quoteRequest);
  }

  getErrorMessages() {
    const messages = [];
    if (this.shippmentTypeMessage !== '') {
      messages.push(this.shippmentTypeMessage);
    }
    return messages;
  }


  // step 4

  downloadCopy() {
    const modalRef = this.modalService.open(DownloadCopyComponent, {
      backdrop: 'static',
      keyboard: false
    });
    modalRef.componentInstance.worksheetId = this.worksheetId;
  }

  getPlaceOrderFlag() {
    return (!this.submittingOrder && this.worksheet.isQuoted);
  }

  onShipViaChecked(shipViaCode: string) {
    this.isPdgPriceCalculated = false;
    this.orderDetail.orderOption.shipViaCode = shipViaCode;
    this.customDeliveryDate = false;
    this.orderDetail.orderOption.isCustomDelivery = false;
    this.clearShipAmountFlag = false;
    this.calculatePDG(shipViaCode);
  }

  clearErrorAndWarnings() {
    this.errorMessages$.next(undefined);
    this.warningMessages$.next(undefined);
  }

  closeErrorMessage() {
    this.errorMessages$.next(undefined);
  }

  closeWarningMessage() {
    this.warningMessages$.next(undefined);
  }

  calculatePDG(shipViaCode: string) {
    let existingShipViaOptionsArray: ShipViaOption[] = [];
    existingShipViaOptionsArray = this.orderDetail.shipViaOptions;
    this.clearErrorAndWarnings();
    // let messageLine1 = `Calculating PDG for <strong>${ this.getDeliverySpeed(shipViaCode) }</strong>. `;
    // let messageLine2 = "This may take several seconds to complete.";
    // const modalRef = this.modalService.open(DisplayMessageModalComponent, {
    //     backdrop: 'static',
    //     keyboard: false
    // });
    // modalRef.componentInstance.bodyMsg1 = messageLine1 + messageLine2;
    this.quoteRequest.worksheetId = this.worksheetId;
    this.quoteRequest.shipViaOption = this.orderDetail.orderOption.shipViaCode;
    this.quoteRequest.requestedDeliveryDate = this.orderDetail.orderOption.requestedDeliveryDate;
    this.quoteRequest.isCustomDelivery = this.orderDetail.orderOption.isCustomDelivery;
    this.quoteRequest.isCheckout = true;
    this.projectService.getOrderSimulation2(this.quoteRequest).subscribe(data => {
        // modalRef.close();
        this.isPdgPriceCalculated = true;
        this.orderDetail = data;
        this.shippingAndHandling = this.orderDetail.shippingAndHandling;
        let newShipViaOptionsArray: ShipViaOption[] = [];
        this.orderDetail.shipViaOptions.forEach(shipViaData => {
            if (shipViaCode === shipViaData.code) {
              newShipViaOptionsArray.push(shipViaData);
            }
        });
        //pushing old array values which are having prices
        existingShipViaOptionsArray.forEach(existingShipViaData => {
            if (existingShipViaData.code !== shipViaCode) {
                newShipViaOptionsArray.push(existingShipViaData);
            }
        });
        this.orderDetail.shipViaOptions = newShipViaOptionsArray;
        this.orderDetail.orderOption.shipViaCode = shipViaCode;
        this.checkBulkOrParcel(false);
        this.filterShipViaOptionsIfHazmatItemPresent();
    }, error => {
        // modalRef.close();
        const message = error.error.message ? error.error.message.split("\n") : ['Internal Server Error.'];
        this.errorMessages$.next([message]);
    });
   }

  calculatePDGForAllOptions() {
    this.clearErrorAndWarnings();
    let isShipViaCodeAlreadySelected: boolean = false;
    let alreadySelectedShipViaCode;
    let averageTimeForSimulation = this.averageTimeForSimulation != null ? this.averageTimeForSimulation : "30";
    if (this.orderDetail.orderOption.shipViaCode != null) {
        isShipViaCodeAlreadySelected = true;
        alreadySelectedShipViaCode = this.orderDetail.orderOption.shipViaCode;
    }

    const confirmationModelRef = this.modalService.open(ConfirmationModalComponent, {
        backdrop: 'static',
        keyboard: false
    });
    confirmationModelRef.componentInstance.headerMsg = "Warning!";
    confirmationModelRef.componentInstance.bodyMsg = `Calculating PDG for all shipping options could take <strong>${averageTimeForSimulation} seconds </strong> to complete. Do you wish to proceed ?`;
    confirmationModelRef.componentInstance.primaryButtonText = "Yes, Proceed";


    confirmationModelRef.componentInstance.fn = () => {
        confirmationModelRef.close();
        let messageLine1 = "Calculating PDG for all shipping options. ";
        let messageLine2 = `This could take <strong>${ averageTimeForSimulation } seconds</strong> to complete.`;
        const displayMsgModalRef = this.modalService.open(DisplayMessageModalComponent, {
            backdrop: 'static',
            keyboard: false
        });
        displayMsgModalRef.componentInstance.bodyMsg1 = messageLine1 + messageLine2;
        this.quoteRequest.worksheetId = this.worksheetId;
        this.quoteRequest.shipViaOption = "ALL";
        this.quoteRequest.forceSimulation = true;
        this.quoteRequest.requestedDeliveryDate = this.orderDetail.orderOption.requestedDeliveryDate;
        this.quoteRequest.isCustomDelivery = this.orderDetail.orderOption.isCustomDelivery;
        this.quoteRequest.isCheckout = true;
        this.projectService.getOrderSimulation2(this.quoteRequest).subscribe(data => {
            this.orderDetail = data;
            if (isShipViaCodeAlreadySelected) {
              this.orderDetail.orderOption.shipViaCode = alreadySelectedShipViaCode;
            }
            this.checkBulkOrParcel(false);
            this.filterShipViaOptionsIfHazmatItemPresent();
            displayMsgModalRef.close();
        }, error => {
            const message = error.error.message ? error.error.message.split("\n") : ['Internal Server Error.'];
            this.errorMessages$.next([message]);
            displayMsgModalRef.close();
        });
    };
  }

  private resetShipViaCodeAndItsPrice() {
    this.orderDetail.shipViaOptions.forEach(shipViaData => {
      shipViaData.merchandiseAmountToShip = null;
    });
    this.orderDetail.orderOption.shipViaCode = null;
  }

  private showWarningMessageIfAnyOpenTasksExists(tasks: Task[]) {
    const openTaskTypes = ['ADDRESS VERIFICATION', 'CABLE CUT'];
    const countOfOpenTasks = this.countOpenTasksByType(tasks, openTaskTypes);
    let addressVerificationCount = countOfOpenTasks['ADDRESS VERIFICATION'] || 0;
    let cableCutCount = countOfOpenTasks['CABLE CUT'] || 0;
    if (addressVerificationCount > 0 || cableCutCount > 0) {

      let taskMessage = (addressVerificationCount > 0 && cableCutCount > 0) ? 'tasks are' : 'task is';
      let message = `The following ` + taskMessage + ` still open for the Worksheet - ` + this.worksheet.siteName + '.<br/><br/>';

      if (addressVerificationCount > 0) {
        message += ('1. Address Verification.' + '<br/>');
      }

      if (cableCutCount > 0) {
        message += addressVerificationCount > 0 ? `2. Cable Cut.` : `1. Cable Cut.`;
        message += cableCutCount > 1 ? ` There are ${cableCutCount} open Cable Cut tasks.` : ` There is 1 open Cable Cut task.`;
      }     
      message += "<br/><br/>If you would like to close the task(s), Please go to <b>My Tasks</b> tab ";
      message += `and complete the pending task(s).`;

      const modal = this.modalService.open(InfoModalComponent, {
        backdrop: 'static',
        keyboard: false
      });
      modal.componentInstance.name = message;
    }
  }

  private countOpenTasksByType(tasks: Task[], taskTypes: string[]) {
    const countByType: { [key: string]: number } = {};
    for (const task of tasks) {
      if (task.opened && taskTypes.includes(task.taskType)) {
        if (countByType[task.taskType]) {
          countByType[task.taskType]++;
        } else {
          countByType[task.taskType] = 1;
        }
      }
    }
    return countByType;
  }

  onPaste(event: ClipboardEvent) {
    const clipboardData = event.clipboardData || (window as any).clipboardData;
    const pastedText = clipboardData.getData('text');
    const regex = /^[A-Za-z0-9\s_#\-():@|~,&*]+$/;
    if (!regex.test(pastedText.trim())) {
      event.preventDefault(); // Prevent the paste action if it doesn't match the regex
      this.displayFailureMsg('PO Number should be alpha numeric along with these special characters \s_#-:@|~,&*()', 'Warning!');
    }
  }

  onKeyPress(event: KeyboardEvent) {
    const inputChar = event.key;
    const regex = /^[A-Za-z0-9\s_#\-():@|~,&*]+$/;
    if (!regex.test(inputChar.trim()) && inputChar!== " ") {
      event.preventDefault(); // Prevent the paste action if it doesn't match the regex
      this.displayFailureMsg('PO Number should be alpha numeric along with these special characters \s_#-:@|~,&*()', 'Warning!');
    }
  }

  private displayFailureMsg(message, text) {
    this.toastr.error(message, text, {
      timeOut: 5000,
      positionClass: 'toast-bottom-right'
    });
  }

  goBack(): void {
    if (this.worksheet && !this.worksheet.isQuoted && !this.submittingQuote) {
      this.router.navigate(['/dashboard', { outlets: { 'dashboard-content': ['order-worksheet', this.worksheet.id] } }]);
    } else if (!this.worksheet) {
      this.router.navigate(['/dashboard', { outlets: { 'dashboard-content': 'my-oasis' } }]);
    } else if (!this.submittingOrder) {
      this.location.back();
    }
  }

  sendDataToAnalytics(type: 'quote_submission' | 'order_submission', quoteOrOrderNum: string) {
    if (type == 'quote_submission') {
      this.analyticsService.trackQuoteSubmission(quoteOrOrderNum);
    } else {
      this.analyticsService.trackOrderSubmission(quoteOrOrderNum);
    }
  }
}


// WEBPACK FOOTER //
// /codebuild/output/src3408204168/src/bitbucket.org/tesscotds/webclient/src/app/checkout/checkout.component.ts